function Order(props) {
  return <h1>Đơn hàng</h1>;
}

export default Order;
